export enum RabotNetworkEnum {
  BASE = 'BASE',
  POLYGON = 'POLYGON',
  OPTIMISM = 'OPTIMISM',
  MONAD_TESTNET = 'MONAD_TESTNET',
}
